module.exports = __webpack_public_path__ + "static/media/SnappyLogo.d7a8f640.svg";